'use client';
import React from 'react';

import { useVisibleVersion } from '@/context/VisibleVersionProvider';
import { getHeadings } from '@/ui/components/ParsedContent/getHeadings';
import SideMenu from '@/ui/components/SideMenu';

interface Heading {
  hashAnchor: string;
  title: string;
  type: string;
}

interface HeadingsListProps {
  headingTitle?: string;
  headingsArray?: Heading[] | null;
  articleContent?: string | null;
  // visibleVersion: string;
}

export default function HeadingsList({
  headingTitle = 'Contents',
  headingsArray = null,
  articleContent = null,
}: // visibleVersion = '',
HeadingsListProps) {
  const { visibleVersion } = useVisibleVersion();
  const headings = React.useMemo(
    () => headingsArray || (articleContent ? getHeadings(articleContent) : []),
    [headingsArray, articleContent]
  );

  return (
    <SideMenu
      heading={headingTitle}
      items={headings}
      headingSize="h6"
      headingComponent="h2"
      upperCaseHeading={false}
      visibleVersion={visibleVersion}
    />
  );
}
